import React from 'react';

import styleHelper from './../helpers/style';


const GifSlide = React.createClass({
  /**
   * Used by React as the component name
   */
  displayName: 'GifSlide',


  /**
   * Used by React as the component name
   */
  countInterval: 0,


  /**
   * Timeout to hide cover image
   */
  hideCoverImageTimeout: 0,


  /**
   * Timeout to render gif element
   */
  loadGifTimeout: 0,


  /**
   * Expected propTypes
   * @prop {Boolean} active - If this is the current active slide
   * @prop {Object} cssTransforms3d - Whether the browser
   * supports css 3d transforms
   * @prop {Object} data - A data object
   * @prop {Number} height - The height for the slide's style
   * @prop {Boolean} large - If the user is viewing the large experience
   * @prop {Boolean} next - If this is the next from the active slide
   * @prop {Boolean} prev - If this is the previous from the active slide
   * @prop {Number} yPosition - The top position for the slide's style
   */
  propTypes: {
    active: React.PropTypes.bool,
    cssTransforms3d: React.PropTypes.bool,
    data: React.PropTypes.object.isRequired,
    height: React.PropTypes.number,
    touch: React.PropTypes.bool,
    large: React.PropTypes.bool.isRequired,
    next: React.PropTypes.bool,
    prev: React.PropTypes.bool,
    yPosition: React.PropTypes.number,
  },


  /**
   * Get initial state object
   * @returns {Object} initial state
   */
  getInitialState() {
    return {
      emojiCountInt: 0,
      gifLoaded: false,
      gifLoading: false,
      hideCoverImage: false,
      emojiCountStarted: false,
      emojiCounts: this._getEmptyCountArray(),
      gifElement: null,
    };
  },


  /**
   * Called after component updates
   * @returns {undefined} undefined
   */
  componentDidUpdate() {
    // if this slide is active and the count up hasn't started, start it
    if (this.props.active && !this.state.emojiCountStarted) {
      this.setState({ emojiCountStarted: true }, () => {
        this._countUpEmojiCount();
      });
    }


    // if this slide is not active and the count has started, stop it
    if (!this.props.active && this.state.emojiCountStarted) {
      clearInterval(this.countInterval);
      this.setState({
        emojiCounts: this._getEmptyCountArray(),
        emojiCountStarted: false,
      });
    }


    // if this slide is active and the gif isn't loaded, load it
    if (this.props.active && !this.state.gifLoaded) {
      if (!this.state.gifLoading) {
        this.setState({ gifLoading: true });

        this.loadGifTimeout = setTimeout(() => {
          if (this.isMounted()) {
            this.setState({ gifElement: this._renderGif() });
          }
        }, 300);
      }
    }

    // if this slide is active and the gif is loaded, show it
    if (this.props.active && this.state.gifLoaded && !this.state.hideCoverImage) {
      this.loadGifTimeout = setTimeout(() => {
        if (this.isMounted()) {
          this.setState({ gifElement: this._renderGif() });
        }
      }, 300);
    }


    // if this slide is not active and the cover image isn't showing, show it
    if (!this.props.active && this.state.hideCoverImage) {
      clearTimeout(this.hideCoverImageTimeout);
      this.setState({
        gifElement: null,
        hideCoverImage: false,
      });
    }


    // if this slide is not active and the gif is loading, hide the loader
    if (!this.props.active && this.state.gifLoading) {
      clearTimeout(this.loadGifTimeout);
      this.setState({
        gifElement: null,
        gifLoading: false,
      });
    }
  },


  /**
   * Renders component
   * @returns {Object} React element
   */
  render() {
    const data = this.props.data;
    const coverImage = this._renderCoverImage();
    const gif = this.state.gifElement;
    const emojis = this._renderEmojis();
    const prevClass = this.props.prev ? ' prev' : '';
    const activeClass = this.props.active ? ' active' : '';
    const nextClass = this.props.next ? ' next' : '';
    const gifLoadingClass = this.state.gifLoading ? ' gif-loading' : '';
    const gifLoadedClass = this.state.gifLoaded ? ' gif-loaded' : '';
    const className = 'component-gif-slide slide' +
      prevClass +
      activeClass +
      nextClass +
      gifLoadedClass +
      gifLoadingClass;
    const style = {
      height: this.props.height,
      top: this.props.yPosition,
    };

    return (
      <div style={style} className={className}>
        <div className='cover-image'>{coverImage}</div>
        <div className='gif'>{gif}</div>
        <div className='gradient' />
        <div className='text'>
          <div className='game-title'>{data.gameTitle}</div>
          <div className='title'>{data.title}</div>
          <div className='emojis'>{emojis}</div>
        </div>
        <div className='loader-wrapper'>
          <div className='loader' />
        </div>
      </div>
    );
  },


  /**
   * Renders the cover image
   * @returns {ReactElement} an image tag
   */
  _renderCoverImage() {
    const data = this.props.data;
    let coverImage;
    const containerWidth = this.props.large ? 400 : window.innerWidth;

    if (!this.state.hideCoverImage) {
      const imageStyle = styleHelper.getSizeToCover(
        data.coverImage.width,
        data.coverImage.height,
        containerWidth,
        containerWidth);

      coverImage = (
        <img style={imageStyle} src={data.coverImage.url} />
      );
    }

    return coverImage;
  },


  /**
   * Renders the gif
   * @returns {ReactElement} an image tag
   */
  _renderGif() {
    const data = this.props.data;
    const containerWidth = this.props.large ? 400 : window.innerWidth;
    let gif;

    if (this.props.active) {
      const imageStyle = styleHelper.getSizeToCover(
        data.image.width,
        data.image.height,
        containerWidth,
        containerWidth);

      const onGifLoad = this.state.gifLoaded ? null : this._onGifLoad;

      gif = (
        <img
          style={imageStyle}
          src={data.image.url}
          onLoad={onGifLoad}
        />
      );

      if (this.state.gifLoaded) {
        this._onGifLoad();
      }
    }

    return gif;
  },


  /**
   * Callback for when gif is loaded
   * @returns {undefined} undefined
   */
  _onGifLoad() {
    if (this.props.active) {
      if (!this.state.gifLoaded) {
        this.setState({ gifLoaded: true, gifLoading: false });
      }

      this.hideCoverImageTimeout = setTimeout(() => {
        if (this.isMounted()) {
          this.setState({ hideCoverImage: true });
        }
      }, 400);
    }
  },


  /**
   * Renders emojis
   * @returns {Array<ReactElement>} An array of ReactElements
   */
  _renderEmojis() {
    const data = this.props.data;
    const emojis = [];

    for (let i = 0; i < data.emojis.length; i++) {
      const key = 'gif-slide-' + data.id + '-emoji-' + i;

      emojis.push(
        <div key={key} className='emoji-item'>
          <div className='emoji'>{data.emojis[i].character}</div>
          <div className='count'>{this.state.emojiCounts[i].currentCount} TWEETS</div>
        </div>
      );
    }

    return emojis;
  },


  /**
   * Counts up the Emoji usage count
   * @returns {undefined} undefined
   */
  _countUpEmojiCount() {
    const _this = this;
    const data = this.props.data;
    const highestEmojiCount = this._getHighestEmojiCount();
    let stopInterval = false;

    this.countInterval = setInterval(() => {
      if (_this.isMounted()) {
        const countArray = this.state.emojiCounts;

        for (let i = 0; i < this.state.emojiCounts.length; i++) {
          const curCount = this.state.emojiCounts[i].currentCount;
          let newCount = curCount + 2;
          if (newCount > this.state.emojiCounts[i].totalCount) {
            newCount = this.state.emojiCounts[i].totalCount;
          }

          if (newCount <= this.state.emojiCounts[i].totalCount) {
            countArray[i] = {
              currentCount: newCount,
              totalCount: data.emojis[i].count,
            };
          }

          if (newCount >= highestEmojiCount) {
            stopInterval = true;
          }
        }

        if (!stopInterval) {
          this.setState({ emojiCounts: countArray });
        } else {
          clearInterval(_this.countInterval);
        }
      } else {
        clearInterval(_this.countInterval);
      }
    }, 10);
  },


  /**
   * Gets the count for the most used emoji
   * @returns {Number} The count for the most used emoji
   */
  _getHighestEmojiCount() {
    let highestCount = 0;
    const data = this.props.data;

    for (let i = 0; i < data.emojis.length; i++) {
      if (data.emojis[i].count > highestCount) {
        highestCount = data.emojis[i].count;
      }
    }

    return highestCount;
  },


  /**
   * Gets an empty count array
   * @returns {Array<Object>} An array of objects
   */
  _getEmptyCountArray() {
    const data = this.props.data;
    const countArray = [];

    for (let i = 0; i < data.emojis.length; i++) {
      countArray.push({
        currentCount: 0,
        totalCount: data.emojis[i].count,
      });
    }

    return countArray;
  },
});

export default GifSlide;



/** WEBPACK FOOTER **
 ** ./assets/js/src/components/GifSlide.jsx
 **/